import api from "../api";

export const inspectionTypesService = {
  // Get all inspection types (for DataTables)
  getInspectionTypes: (params = {}) => {
    const defaultParams = {
      draw: 1,
      start: 0,
      length: 30,
      search: { value: "", regex: false },
      order: [{ column: 0, dir: "asc" }],
      columns: [
        { data: "name", name: "name", searchable: true, orderable: true },
        { data: "color", name: "color", searchable: true, orderable: true },
        {
          data: "actions",
          name: "actions",
          searchable: false,
          orderable: false,
        },
      ],
    };

    return api.post("/inspection-types", {
      ...defaultParams,
      ...params,
    });
  },

  // Get single inspection type
  getInspectionType: (id) => {
    return api.get(`/inspection-types/${id}`);
  },

  // Create new inspection type
  createInspectionType: (data) => {
    return api.post("/inspection-types", data);
  },

  // Update inspection type
  updateInspectionType: (id, data) => {
    return api.put(`/inspection-types/${id}`, data);
  },

  // Delete inspection type
  deleteInspectionType: (id) => {
    return api.delete(`/inspection-types/${id}`);
  },

  // Get inspection types for dropdown/select
  getInspectionTypesList: () => {
    return api.get("/inspection-types/list");
  },

  // Mock data for development/testing
  getMockInspectionTypes: () => {
    return [
      {
        id: 1,
        name: 'Absence',
        color: ''
      },
      {
        id: 2,
        name: 'Access',
        color: 'red'
      },
      {
        id: 3,
        name: 'Final Inspection',
        color: '#dc3545'
      },
      {
        id: 4,
        name: 'Hand Back',
        color: '#ffff00'
      },
      {
        id: 5,
        name: 'Holiday',
        color: ''
      },
      {
        id: 6,
        name: 'Initial Inspection',
        color: ''
      },
      {
        id: 7,
        name: 'Monthly Inspection',
        color: '#5bc0de'
      },
      {
        id: 8,
        name: 'Annual Inspection',
        color: '#5cb85c'
      },
      {
        id: 9,
        name: 'Emergency Inspection',
        color: '#d9534f'
      },
      {
        id: 10,
        name: 'Pre-occupancy Inspection',
        color: '#f0ad4e'
      }
    ];
  }
};
